import { render, staticRenderFns } from "./UserCoupons.vue?vue&type=template&id=264536dc&"
import script from "./UserCoupons.vue?vue&type=script&lang=js&"
export * from "./UserCoupons.vue?vue&type=script&lang=js&"
import style0 from "./UserCoupons.vue?vue&type=style&index=0&id=264536dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports